import React, { useState } from 'react';
import { Virtuoso } from 'react-virtuoso';

import { LoadMore, Spinner, Avatar, MCText } from 'src/components/basic';
import BaseComponent from 'src/components/BaseComponent';

import { withRouter, userFullName, lang, scssVariables, rgba } from 'src/helpers';
import SVGIcon, { BASE_ICONS } from 'src/components/svg';
import constants from 'src/constants';

import mainModel from 'src/pages/main/model';
import { getUnavailableStateForNow } from 'src/helpers';

import model from './model';
import moment from 'moment';
import { UnreadBadge } from '../basic/UnreadBadge';
import LANG_CONST from 'src/helpers/lang/const';

const ArchiveButton = () => {
  let [archiveExpanded, setArchiveExpanded] = useState(false);
  let avatarName = lang.t('Archived chats');
  let name = avatarName;
  let value = '';
  let unread = model.getState().archiveUnreadCounter || 0;
  let active = model.getState().archive;

  return (
    <div
      data-testid='message-contact-item'
      className={`mc-contacts__item mc-contacts__archive ${active ? 'mc-bg-active' : ''} ${archiveExpanded ? 'expanded' : ''}`}
      onClick={() => {
        model.setState({
          archive: !model.state.archive,
          current: model.state.archive ? 'recent' : 'archive'
        });
        model.refresh();
      }}
    >
      {archiveExpanded && (
        <>
          <Avatar width={50} height={50} text={avatarName} onlineState={''} image={''} />
          <div className={'mc-flex-5-col mc-grow'} style={{ minWidth: 0 }}>
            <div className={'mc-value-618 mc-text-truncate'}>{name}</div>
            <div className={'mc-label-416 mc-text-truncate'}>{value}</div>
          </div>
        </>
      )}
      {!archiveExpanded && (
        <>
          <div className={'mc-flex-5-col mc-grow'} style={{ minWidth: 0 }}>
            <div className={'mc-value-618 mc-text-truncate'}>{name}</div>
          </div>
        </>
      )}
      <div className={'mc-flex-5-col mc-time'}>
        {unread > 0 && <div className={'mc-unread'}>{unread > 9 ? '9+' : unread}</div>}
      </div>
      <span
        onClick={(e) => {
          setArchiveExpanded(!archiveExpanded);
          e.stopPropagation();
        }}
      >
        <SVGIcon
          iconname={archiveExpanded ? BASE_ICONS.UP : BASE_ICONS.DOWN}
          width={20}
          fill={scssVariables['colors-mc-text-light']}
        />
      </span>
    </div>
  );
};

class ContactsList extends BaseComponent {
  componentDidMount() {
    model.subscribe(this.subscription);
    model.loadArchiveCounter();
    model.on('contactOpened', this.onContactOpened);
  }

  componentWillUnmount() {
    model.unsubscribe(this.subscription);
    model.cancel('contactOpened', this.onContactOpened);
  }

  componentDidUpdate(prevProps) {
    if (this.props.router.params?.id !== prevProps.router.params?.id) {
      model.openId(this.props.router.params.id);
    }
  }

  onContactOpened = (contact) => {
    let username = contact.partnerProfile?.username || contact.username;
    let routerParams = this.props.router.params;
    if (username && routerParams && routerParams.id != username) {
      this.props.router.navigate(
        (this.props.isAdminPage ? '/admin' : '') + '/messages/' + username
      );
    }
  };

  getLabel = (item) => {
    if (!item) return '';
    return item.group == 'contacts' ? 'Contacts' : item.group == 'doctors' ? 'Doctors' : 'Users';
  };

  renderItem = (index, item, items) => {
    let isSearch = !!model.listInput('search');
    let label = null;
    let showLoadMore = false;
    let loading = false;
    if (isSearch) {
      let prevItem = index > 0 ? items[index - 1] : null;
      let nextItem = index + 1 < items.length ? items[index + 1] : null;
      label = this.getLabel(item) != this.getLabel(prevItem) ? this.getLabel(item) : null;
      showLoadMore =
        this.getLabel(item) != this.getLabel(nextItem)
          ? model.state.hasMoreSearch[item.group]
          : false;
      let apiId =
        item.group == 'contacts'
          ? 'loadMoreSearchContacts'
          : item.group == 'doctors'
            ? 'loadMoreSearchDoctors'
            : 'loadMoreSearchUsers';
      loading = model.getApiState(apiId).loading;
    }

    const auth = mainModel.getUser();
    const unread = (item.users || []).find((u) => u._id === auth?.id)?.unread;
    let value =
      typeof item.lastMessage === 'string' || !isNaN(item.lastMessage)
        ? item.lastMessage
        : item.lastMessage && item.lastMessage?.data?.type !== 'text'
          ? JSON.parse(item.lastMessage.data.value)
          : item.lastMessage?.data?.value;
    if (!value && item.isDoctor) {
      let specialist =
        item.specialist || (item.partnerProfile && item.partnerProfile.specialist) || [];
      specialist = specialist.map((spec) => {
        let found = constants.general.specialist.find((s) => s.value == spec);
        return (found && found.label) || spec;
      });

      value = specialist.join(', ');
    }
    let lastMessageTime =
      typeof item.lastMessage === 'string' ||
      !isNaN(item.lastMessage) ||
      !!item.lastMessage?.add_date
        ? item.posted
        : item.lastMessage?.add_date;
    let avatarName = userFullName(item);
    let name = userFullName(item, item.isDoctor);
    let active = model.isActive(item.partnerId || item.id);
    const hospital =
      item.partnerProfile?.role?.indexOf('_') !== -1
        ? item.partnerClinicProfile?.username
        : lang.t('Independent');
    let partnerUsername = item.partnerProfile?.username || item.id;
    return (
      <>
        {!!label && isSearch && <div className='mc-value-418 mc-p20'>{label}</div>}
        <div
          data-testid={'message-contact-item'}
          className={'mc-contacts__item ' + (active ? 'mc-bg-active' : '')}
          key={'mc-message-' + item.id}
          onClick={() => {
            this.props.router.navigate(
              (this.props.isAdminPage ? '/admin' : '') + '/messages/' + partnerUsername
            );
          }}
        >
          <Avatar
            width={50}
            height={50}
            text={avatarName}
            onlineState={
              getUnavailableStateForNow(item?.accountState)
                ? 'not_available'
                : item.partnerOnline > 0
                  ? 'online'
                  : ''
            }
            image={(item.avatar || '').replace('/full_', '/350_')}
          />
          <div className={'mc-flex-5-col mc-grow'} style={{ minWidth: 0 }}>
            <div className={'mc-value-618 mc-text-truncate'}>{name}</div>

            {item.isDoctor && item.status === constants.general.userStatus.disabled ? (
              <MCText
                label={LANG_CONST.unavailable}
                style={{ color: rgba(scssVariables['colors-mc-orange'], 0.7) }}
                size={16}
              />
            ) : (
              <div className={'mc-label-416 mc-text-truncate'}>{value}</div>
            )}

            {isSearch && item.isDoctor && hospital && (
              <div className={'mc-label-416 mc-text-truncate'}>{hospital}</div>
            )}
          </div>
          <div className={'mc-flex-5-col mc-time'}>
            <pre className={'mc-label-414'}>
              {lastMessageTime
                ? moment(lastMessageTime).calendar({
                    sameDay: 'hh:mm A',
                    lastDay: '[Yesterday\nat] hh:mm A',
                    lastWeek: '[Last] dddd',
                    sameElse: (d) => {
                      const now = moment();
                      if (now.year() === d.year()) {
                        return 'MMM DD';
                      }
                      return 'MMM, YYYY';
                    }
                  })
                : ''}
            </pre>
            <UnreadBadge unread={unread > 99 ? '99+' : unread} />
          </div>
        </div>
        {showLoadMore && (
          <LoadMore
            loading={loading}
            onClick={() => !loading && model.loadMoreSearch(item.group)}
          />
        )}
      </>
    );
  };

  render() {
    const items = model.items();
    const auth = mainModel.getUser();
    let noResults = model.noResults();
    let searchQuery = model.listInput('search');
    let loading = model.refreshing();

    return (
      auth &&
      items && (
        <>
          <Virtuoso
            className={'mc-contacts'}
            data={items}
            components={{
              Header: () => (
                <>
                  <div className={'mc-pt20'} />
                  <ArchiveButton />
                </>
              ),
              Footer: () => (
                <div style={{ textAlign: 'center', padding: '1rem' }}>
                  {noResults && !searchQuery && <div>{lang.t('No results yet')}</div>}
                  {noResults && searchQuery && <div>{lang.t('Nothing found')}</div>}
                  {loading && <Spinner />}
                </div>
              )
            }}
            endReached={() => {
              if (!searchQuery && model.hasMore() && !model.refreshing()) model.loadMore();
            }}
            itemContent={(index, item) => {
              return this.renderItem(index, item, items);
            }}
          />
        </>
      )
    );
  }
}

export default withRouter(ContactsList);
